// extracted by mini-css-extract-plugin
export var black = "_1w-6";
export var brand = "_1w-1";
export var ddefault = "_1w-0";
export var error = "_1w-3";
export var gray = "_1w-2";
export var highContrast = "_1w-8";
export var outline = "_1w-7";
export var success = "_1w-5";
export var warning = "_1w-4";